export default __webpack_public_path__ + "static/media/Chhattisgarhi_bf_2.ec6b9fd4.mp3";